export const mapShortProfessorToProfessor = language => ({
  id,
  name,
  image,
  description,
  organisation,
  organisationUrl,
  jobTitle
}) => {
  return {
    contentId: id,
    descriptions: {
      [language.toLowerCase()]: description
    },
    id,
    image: image || '',
    metadata: [],
    name,
    organisation: organisation || undefined,
    organisationUrl: organisationUrl || undefined,
    jobTitle: jobTitle || undefined,
    updatedAt: 0
  };
};